import { createError } from '@adv-frontend/error';

/**
 * Ошибка сообщающая о наличии триггера сайд-эффекта во время выполнения data генератора реакции
 *
 * Сайд-эффекты должны быть описаны в эффекте реакции
 */
export const SideEffectInDataError = createError('SideEffectInDataError');

/**
 * Ошибка сообщающая о превышении лимита запусков экземпляра реакции
 */
export const ExecutionsLimitReachedError = createError('ExecutionsLimitReachedError');

/**
 * Ошибка сообщающая о превышении лимита нотификаций запусков реакции
 */
export const NotifiesLimitReachedError = createError('NotifiesLimitReachedError');

/**
 * Ошибка сообщающая о превышении лимита количества существующих экземпляров реакций
 */
export const InstancesCountLimitReachedError = createError('InstancesCountLimitReachedError');
